/**
 * Created by desheng.zhao on 2018/11/30.
 */
import * as filters from './filters'

// 全局过滤器
export const global = {
  ...filters,
};

// 局部过滤器
export const local = {
  ...filters
};



// WEBPACK FOOTER //
// ./src/filters/index.js